import React from 'react';
import { Search } from 'lucide-react';
import { TIERS } from './constants';

const BAR_STYLE = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem',
  alignItems: 'center',
  margin: '0 0 1rem',
  padding: '0.75rem',
  background: 'rgba(255, 215, 0, 0.04)',
  border: '1px solid rgba(255, 215, 0, 0.18)',
  borderRadius: '10px',
};

const INPUT_STYLE = {
  width: '100%',
  padding: '0.5rem 0.5rem 0.5rem 2rem',
  borderRadius: '8px',
  border: '1px solid rgba(255,215,0,0.3)',
  background: '#0a0a0a',
  color: '#fff',
};

const SELECT_STYLE = {
  padding: '0.5rem 0.75rem',
  borderRadius: '8px',
  border: '1px solid rgba(255,215,0,0.3)',
  background: '#0a0a0a',
  color: '#fff',
};

const SponsorsFilters = ({
  searchQuery,
  setSearchQuery,
  tierFilter,
  setTierFilter,
  filteredCount,
  totalCount,
}) => (
  <div className="admin-search-bar" style={BAR_STYLE}>
    <div style={{ position: 'relative', flex: '1 1 260px', minWidth: '220px' }}>
      <Search size={16} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#FFD700' }} />
      <input
        type="search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search business, contact, email, notes…"
        data-testid="sponsor-search-input"
        style={INPUT_STYLE}
      />
    </div>
    <select
      value={tierFilter}
      onChange={(e) => setTierFilter(e.target.value)}
      data-testid="sponsor-tier-filter"
      style={SELECT_STYLE}
    >
      <option value="all">All Tiers</option>
      {TIERS.map((t) => (
        <option key={t.value} value={t.value}>{t.label}</option>
      ))}
    </select>
    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 600 }}>
      {filteredCount} of {totalCount}
    </span>
  </div>
);

export default SponsorsFilters;
